import React, { createContext, useContext } from 'react';

// Création du contexte
const MyContext = createContext();

// Export du hook personnalisé pour utiliser le contexte
export const useMyContext = () => useContext(MyContext);

// Export du fournisseur de contexte
export const MyProvider = ({ children }) => {
  const value = {}; // Valeur que vous souhaitez partager via le contexte

  return (
    <MyContext.Provider value={value}>
      {children}
    </MyContext.Provider>
  );
};
